{
  "name": "@tiptap/cli",
  "version": "3.19.4",
  "description": "Tiptap CLI",
  "publishConfig": {
    "access": "public"
  },
  "author": {
    "name": "tiptap",
    "url": "https://github.com/ueberdosis/tiptap"
  },
  "files": [
    "dist"
  ],
  "keywords": [
    "cli",
    "components",
    "nextjs",
    "react",
    "templates",
    "tiptap",
    "@tiptap/cli",
    "ui"
  ],
  "license": "SEE LICENSE IN LICENSE.md",
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "bin": "./dist/index.js",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "clean": "rm -rf dist",
    "start:dev": "cross-env REGISTRY_URL=http://localhost:3000 node dist/index.js",
    "start:prod": "cross-env REGISTRY_URL=https://template.tiptap.dev node dist/index.js",
    "start": "node dist/index.js",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:release": "pnpm build && pnpm publish --access public"
  },
  "dependencies": {
    "@antfu/ni": "^30.2.0",
    "@babel/core": "^7.29.7",
    "@babel/parser": "^7.29.7",
    "@babel/plugin-transform-typescript": "^7.29.7",
    "@inquirer/core": "^11.2.1",
    "@inquirer/figures": "^2.0.7",
    "@inquirer/prompts": "^8.5.2",
    "@inquirer/type": "^4.0.7",
    "ansi-escapes": "^7.3.0",
    "chalk": "^5.6.2",
    "commander": "^14.0.3",
    "conf": "^15.1.0",
    "cosmiconfig": "^9.0.2",
    "deepmerge": "^4.3.1",
    "execa": "^9.6.1",
    "fast-glob": "^3.3.3",
    "fs-extra": "^11.3.5",
    "https-proxy-agent": "^9.1.0",
    "jsonc-parser": "^3.3.1",
    "node-fetch": "^3.3.2",
    "ora": "^9.4.1",
    "recast": "^0.23.11",
    "sass": "^1.101.0",
    "ts-morph": "^28.0.0",
    "tsconfig-paths": "^4.2.0",
    "yaml": "^2.9.0",
    "yoctocolors-cjs": "^2.1.3",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@babel/plugin-transform-typescript": "^7.26.5",
    "@types/babel__core": "^7.20.5",
    "@types/conf": "^3.0.3",
    "@types/fs-extra": "^11.0.4",
    "@types/prompts": "^2.4.9",
    "cross-env": "^10.1.0",
    "tsup": "^8.5.1",
    "type-fest": "^5.7.0",
    "typescript": "^5.9.3",
    "vitest": "^4.1.9"
  }
}
